import {
    Alert,
    Button,
    FormGroup,
    Heading,
    Link,
    Loader,
    NavigationBar,
    NavigationContent,
} from 'arag-ui-lib';
import {LEGAL_ADVICE_TEXT} from '../../helpers/variables';
import StagedStep1 from './WizardSteps/stagedStep1';
import StagedStep2 from './WizardSteps/stagedStep2';
import StagedStep3 from './WizardSteps/stagedStep3';
import StagedStep4 from './WizardSteps/stagedStep4';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import { EDIT_STAGED_APPLICATION_PREMIUM_SETTING_NEXT_STEP, EDIT_STAGED_APPLICATION_PREMIUM_SETTING_OVERVIEW_SUBMIT, 
    ERROR, HEADING_2, HEADING_3, LEFT, PRIMARY, QUATERNARY, RIGHT, SUBMIT, SUCCESS, TERTIARY, WIZARD 
} from '../../helpers/constants';
import { FORM_GROUP_VARIANTS } from '../../helpers/formGroupVariants';
import {useHistory} from 'react-router-dom'
import {redirectToHandler, formatSolicitorOptionLabel} from '../../helpers/functions'
import {PREMIUM_SETTINGS_URL} from '../../helpers/constants'
import { useEffect } from 'react'
const steps = [
    {label: CONTENT_STRINGS.COMMISSIONS, key: '1'},
    {label: CONTENT_STRINGS.PREMIUMS_AND_LOI, key: '2'},
    {label: CONTENT_STRINGS.NOTES_AND_COVERAGE, key: '3'},
    {label: CONTENT_STRINGS.OVERVIEW, key: '4'},
];
const StagedPremiumSettingsWizard = props => {
    const {
        stagedPremiumSettingsWizard,
        stagedSubSettings,
        formIsFetching,
        changeStageSubSetting,
        agentsList,
        premiumSettings,
        currentStep,
        nextStep,
        previousStep,
        workSourceName,
        isApplicationPremium,
        toggleCommissionModal,
        commissionModal,
        lawsysFirms,
        onSuggestionChange,
        onSuggestionSelected,
        changeStagedPremiumFormData,
        addCommission,
        removeSolicitor,
        displayDataPerStage,
        onCancel,
        isEdit,
        handleSubmit,
        caseTypeName,
        subCaseTypeName,
    } = props;
    const history = useHistory();
    const continueButtonText = currentStep == 4 ? CONTENT_STRINGS.SUBMIT : CONTENT_STRINGS.NEXT_STEP;
    const continueButtonTestId = currentStep == 4 ? EDIT_STAGED_APPLICATION_PREMIUM_SETTING_OVERVIEW_SUBMIT : EDIT_STAGED_APPLICATION_PREMIUM_SETTING_NEXT_STEP;
    const continueButton = currentStep == 4 ? () => handleSubmit() : () => nextStep();
    const disableButtons = stagedPremiumSettingsWizard.posting || stagedPremiumSettingsWizard.patching;
    useEffect(() => {
        if (!isApplicationPremium && stagedPremiumSettingsWizard.successMessage !== '') {
            redirectToHandler(PREMIUM_SETTINGS_URL, history, stagedPremiumSettingsWizard.successMessage);
        }
    }, [isApplicationPremium, stagedPremiumSettingsWizard.successMessage, history]);

    const goingLiveLoading =
        (stagedPremiumSettingsWizard.fetchingStagedPremium ||
        stagedPremiumSettingsWizard.fetchingCoverageTypes ||
        stagedPremiumSettingsWizard.fetchingStages ||
        premiumSettings.fetchingPremiumWithCombination ||
        stagedPremiumSettingsWizard.fetching ||
        premiumSettings.fetching ||
        premiumSettings.fetchingPremiumSettingById ||
        stagedPremiumSettingsWizard.changingApplicationStatus) &&
        !stagedPremiumSettingsWizard.patching;

    const headingTitle = isEdit ? CONTENT_STRINGS.EDIT_STAGED_PREMIUM_SETTING : CONTENT_STRINGS.NEW_STAGED_PREMIUM_SETTING;
    const renderSteps = {
        [1]:    <StagedStep1
                    agentsList={agentsList}
                    changeStagedPremiumFormData={changeStagedPremiumFormData}
                    lawsysFirms={lawsysFirms}
                    toggleCommissionModal={toggleCommissionModal}
                    commissionModal={commissionModal}
                    onSuggestionSelected={onSuggestionSelected}
                    onSuggestionChange={onSuggestionChange}
                    stagedPremiumsWizard={stagedPremiumSettingsWizard}
                    addCommission={addCommission}
                    removeSolicitor={removeSolicitor}
                />,
        [2]:    <StagedStep2
                    agentsList={agentsList}
                    stagedSubSettings={stagedSubSettings}
                    amountColumnsDisplayDataPerStage={displayDataPerStage}
                    stagedPremiumsWizard={stagedPremiumSettingsWizard}
                    changeStageSubSetting={changeStageSubSetting}
                    changeStagedPremiumFormData={changeStagedPremiumFormData}
                />,
        [3]:    <StagedStep3
                    isApplicationPremium={isApplicationPremium}
                    changeStagedPremiumFormData={changeStagedPremiumFormData}
                    stagedPremiumsWizard={stagedPremiumSettingsWizard}
                />,
        [4]:    <StagedStep4
                    amountColumnsDisplayDataPerStage={displayDataPerStage}
                    isApplicationPremium={isApplicationPremium}
                    stagesSubSettings={stagedSubSettings}
                    stagedPremiumData={stagedPremiumSettingsWizard}
                    isWizardRun
                />,
    };
    return (
        <form
            onSubmit={e => {
                e.preventDefault();
                continueButton();
            }}
        >
            {
                isApplicationPremium == false
                ?
                    <Heading variant={HEADING_2} title={headingTitle} headingTestId={'staged-premium-setting-header'} />
                :
                    <Heading variant={HEADING_3} title={CONTENT_STRINGS.APPLICATION_PREMIUM_SETTINGS} />
            }
            {
                premiumSettings.selectedSolicitorGroupName 
                ?
                    <FormGroup
                        labelSize={'col-sm-2'}
                        inputSize={'col-sm-6'}
                        label={`${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.GROUP}`}
                        variant={FORM_GROUP_VARIANTS.PLAIN}
                        inputProps={{
                            name: 'selectedSolicitorGroupName',
                            label: formatSolicitorOptionLabel({ label: premiumSettings.selectedSolicitorGroupName, aragProvider: premiumSettings.selectedSolicitorGroupAragProvider }),
                        }}
                        formGroupTestId={'staged-premium-settings-lawyer-group-select'}
                    />
                : 
                    null
            }
            {
                workSourceName && isApplicationPremium == false
                ?
                    <FormGroup
                        labelSize={'col-sm-2'}
                        inputSize={'col-sm-6'}
                        label={CONTENT_STRINGS.WORK_SOURCE}
                        variant={FORM_GROUP_VARIANTS.PLAIN}
                        inputProps={{
                            name: 'workSourceName',
                            label: workSourceName,
                        }}
                        formGroupTestId={'staged-premium-settings-work-source-select'}
                    />
                :
                    null
            }
            {
                caseTypeName && isApplicationPremium == false
                ?
                    <FormGroup
                        labelSize={'col-sm-2'}
                        inputSize={'col-sm-6'}
                        label={CONTENT_STRINGS.CASE_TYPE}
                        variant={FORM_GROUP_VARIANTS.PLAIN}
                        inputProps={{
                            name: 'caseTypeName',
                            label: caseTypeName,
                        }}
                        formGroupTestId={'staged-premium-settings-case-type-select'}
                    />
                : 
                    null
            }
            {
                subCaseTypeName && isApplicationPremium == false
                ?
                    <FormGroup
                        labelSize={'col-sm-2'}
                        inputSize={'col-sm-6'}
                        label={CONTENT_STRINGS.SUB_CASE_TYPE}
                        variant={FORM_GROUP_VARIANTS.PLAIN}
                        inputProps={{
                            name: 'subCaseTypeName',
                            label: subCaseTypeName,
                        }}
                        formGroupTestId={'staged-premium-settings-sub-case-type-select'}
                    />
                : 
                    null
            }
            <NavigationBar
                onNavItemSelect={() => null}
                activeItemKey={currentStep.toString()}
                variant={WIZARD}
                stepCounter
                navItems={steps}
                navBarTestId={`staged-premium-setting-wizard-nav-step-${currentStep}`}
            />
            {formIsFetching
                ?
                    <div className="col-sm-12">
                        <Loader /> 
                    </div>
                :
                null
            }
            <NavigationContent>
                {renderSteps[currentStep]}
            </NavigationContent>
            {
                formIsFetching == false 
                ?
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>
                        {
                            (disableButtons || goingLiveLoading)
                            ?
                                <div style={{paddingRight: 10}}>
                                    <Loader />
                                </div>
                            : 
                                null
                        }
                        <Button
                            variant={QUATERNARY}
                            label={CONTENT_STRINGS.BACK}
                            disabled={currentStep <= 1 || disableButtons || goingLiveLoading}
                            onClick={previousStep}
                            buttonTestId={'edit-staged-application-premium-setting-back'}
                        />
                        <Button
                            variant={PRIMARY}
                            type={SUBMIT}
                            label={continueButtonText}
                            arrowDirection={RIGHT}
                            disabled={ currentStep > 4 || disableButtons || goingLiveLoading }
                            buttonTestId={continueButtonTestId}
                        />
                    </div>
                :
                    null
            }
            {
                formIsFetching == false
                ?
                    <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end'}}>
                        <Link
                            variant={TERTIARY}
                            arrowDirection={LEFT}
                            label={CONTENT_STRINGS.CANCEL}
                            disabled={disableButtons || goingLiveLoading}
                            onClick={onCancel}
                            linkTestId={'edit-staged-application-premium-setting-cancel'}
                        />
                    </div>
                :
                    null
            }
            {
                stagedPremiumSettingsWizard.errorResponse?.length > 0
                ?
                    <Alert
                        variant={ERROR}
                        label={stagedPremiumSettingsWizard.errorResponse}
                        onDismiss={() =>
                            changeStagedPremiumFormData('errorResponse', '')
                        }
                    />
                :
                    null
            }
            {
                stagedPremiumSettingsWizard.successMessage?.length > 0
                ?
                    <Alert
                        variant={SUCCESS}
                        label={stagedPremiumSettingsWizard.successMessage}
                    />
                :
                    null
            }
        </form>
    );
};
export default StagedPremiumSettingsWizard;